"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2031],{

/***/ 85946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BackArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function BackArrow(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        height: props.height || 24,
        width: props.width || 24,
        viewBox: "0 0 447.243 447.243"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#000000",
            d: "M420.361 192.229a31.967 31.967 0 00-5.535-.41H99.305l6.88-3.2a63.998 63.998 0 0018.08-12.8l88.48-88.48c11.653-11.124 13.611-29.019 4.64-42.4-10.441-14.259-30.464-17.355-44.724-6.914a32.018 32.018 0 00-3.276 2.754l-160 160c-12.504 12.49-12.515 32.751-.025 45.255l.025.025 160 160c12.514 12.479 32.775 12.451 45.255-.063a32.084 32.084 0 002.745-3.137c8.971-13.381 7.013-31.276-4.64-42.4l-88.32-88.64a64.002 64.002 0 00-16-11.68l-9.6-4.32h314.24c16.347.607 30.689-10.812 33.76-26.88 2.829-17.445-9.019-33.88-26.464-36.71z"
        })
    }));
}


/***/ }),

/***/ 67865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90864);
/* harmony import */ var _utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70145);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19372);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77733);
/* harmony import */ var _utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8824);
/* harmony import */ var src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96930);
/**
 * Card Payment Input Component
 */ 













var CardPaymentBox = function(props) {
    var getCtaBtnText = function getCtaBtnText() {
        return props.isVerifyCard ? "VERIFY NOW" : "Pay";
    };
    var ref, ref1;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        cvv: "",
        expiry: "",
        number: "",
        cardType: "",
        isCardNumberValid: true,
        isCardMonthInvalid: false,
        cvvLength: 3
    }), state = ref2[0], setState = ref2[1];
    var ref3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            loader: state.commonReducer.loader,
            storeData: state.storeReducer.store,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge,
            userData: state.userReducer.data
        };
    }), store = ref3.store, orderDetails = ref3.orderDetails, loader = ref3.loader, storeData = ref3.storeData, paymentOptionsWithTxnCharge = ref3.paymentOptionsWithTxnCharge, userData = ref3.userData;
    /**
   * UseEffect for prefilled card data
   */ (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        (store === null || store === void 0 ? void 0 : store.store_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) && dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .fetchPaymentMethods */ .F7)({
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
        }));
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("dscc")) {
            var cardDetails = JSON.parse((0,_utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_11__/* .getEncrypDecryptStr */ .v)(JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("dscc")), "decrypt"));
            newState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state), {
                cvv: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .formatCvc */ .bX)(cardDetails.cCvv),
                expiry: cardDetails.cExpMonth + "/" + cardDetails.cExpYear.slice(-2),
                number: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .cardNumberFormat */ .XW)(cardDetails.cNum),
                cardType: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .getCardType */ .C1)(cardDetails.cNum),
                cvvLength: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .getCardType */ .C1)(cardDetails.cNum) === "AMEX" ? 4 : 3
            });
        }
        setState(newState);
    }, []);
    var handleInputChange = function(key, value, event) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        if (key === "number") {
            newState[key] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .cardNumberFormat */ .XW)(value);
            newState["isCardNumberValid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .isCardValid */ .TH)(value);
            newState["cardType"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .getCardType */ .C1)(value);
            newState["cvvLength"] = newState["cardType"] === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CARD_TYPE.AMEX */ .WK.AMEX ? 4 : 3;
        } else if (key === "expiry") {
            newState["expiry"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .formatExpiry */ .Tn)(event);
        } else if (key === "cvv") {
            newState["cvv"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .formatCvc */ .bX)(value);
        }
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
    };
    /**
   * this function is written to check the exact card type in pascal,
   * as required by the enterprise team for the mdr check api
   * @param {*} cardInfo
   * @return {string}
   */ var returnCardTypeString = function(cardInfo) {
        if (cardInfo.card_type === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CARD_TYPE.AMEX */ .WK.AMEX && cardInfo.category === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD.toLowerCase */ .Mf.CREDIT_CARD.toLowerCase()) {
            return _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.AMEX_CARD */ .Mf.AMEX_CARD;
        } else {
            switch(cardInfo.category){
                case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD.toLowerCase */ .Mf.DEBIT_CARD.toLowerCase():
                    return _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */ .Mf.DEBIT_CARD;
                case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD.toLowerCase */ .Mf.CREDIT_CARD.toLowerCase():
                    return _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */ .Mf.CREDIT_CARD;
                default:
                    return "";
            }
        }
    };
    var callForSpecificCardDetails = function(value, callback) {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .checkCardInfo */ .Jd)(value, function(status, data) {
            if (status && !!data) {
                if ((data === null || data === void 0 ? void 0 : data.card_type) === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CARD_TYPE.AMEX */ .WK.AMEX) {
                    var payment_modes = paymentOptionsWithTxnCharge.payment_modes;
                    if (payment_modes === null || payment_modes === void 0 ? void 0 : payment_modes.length) {
                        var amexCardData = payment_modes === null || payment_modes === void 0 ? void 0 : payment_modes.find(function(payment) {
                            return payment.payment_option_name === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.AMEX_CARD */ .Mf.AMEX_CARD;
                        });
                        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .setCustomerTransactionPaymentMethod */ .j1)(amexCardData));
                    }
                }
                var payload = {
                    order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                    store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                    payment_option: {
                        payment_option_name: returnCardTypeString(data)
                    }
                };
                dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .prePaymentCheckMDRTransactions */ .HV)(payload, callback));
            }
        }));
    };
    var validateAll = function() {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        var isAllValid = true;
        if (!state.number) {
            newState["isCardNumberValid"] = false;
            isAllValid = false;
        }
        if (!state.expiry) {
            newState["isCardMonthInvalid"] = "Enter a valid expiry";
            isAllValid = false;
        }
        if (state.cvvLength !== state.cvv.length) {
            newState["isCardCVVInvalid"] = "Enter a valid CVV";
            isAllValid = false;
        }
        setState(newState);
        return isAllValid;
    };
    var validateCardNumber = function(number) {
        var ref;
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        newState["isCardNumberValid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .isCardValid */ .TH)(number);
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
        if ((storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) && number.split(" ").join("").length >= 6) {
            var cardNo = newState["number"].trim().split(" ").join("").substring(0, 6);
            callForSpecificCardDetails(cardNo);
        }
    };
    var validateCardMonth = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        newState["isCardMonthInvalid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .isExpiryInvalid */ .G9)(number);
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
    };
    var validateCardCVV = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        newState["isCardCVVInvalid"] = number.length !== state.cvvLength ? "Enter valid CVV" : false;
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
    };
    var checkForValidCardLogic = function() {
        var ref, ref1;
        return ((ref1 = (ref = state.number) === null || ref === void 0 ? void 0 : ref.split(" ")) === null || ref1 === void 0 ? void 0 : ref1.join("").length) >= 14 && state.isCardNumberValid && !state.isCardMonthInvalid;
    };
    var onPayBtnClick = function() {
        if ((0,src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_8__/* .canDisablePlaceOrder */ .w)()) {
            return;
        }
        if (validateAll() && checkForValidCardLogic()) {
            var ref, ref1, ref2, ref3;
            var data = {
                orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                phone: userData === null || userData === void 0 ? void 0 : userData.phone,
                paymentMethod: "card",
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceInfo */ .d)().OSName,
                browserType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceInfo */ .d)().BrowserName,
                userAgent: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceInfo */ .d)().userAgent,
                source: "longtail",
                cNum: state.number.split(" ").join(""),
                cCvv: state.cvv,
                cName: "Dotpe",
                cExpMonth: state.expiry.split("/")[0].trim(),
                cExpYear: "20" + state.expiry.split("/")[1].trim(),
                merchantName: "Digital Showroom - ".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.name)
            };
            var encryptCCDetails = (0,_utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_11__/* .getEncrypDecryptStr */ .v)(JSON.stringify(data), "encrypt");
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("dscc", JSON.stringify(encryptCCDetails));
            if (props.isVerifyCard) {
                props.onVerifyCard(data);
            } else {
                var ref4;
                if (storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.services) === null || ref4 === void 0 ? void 0 : ref4.mdr_flag) {
                    callForSpecificCardDetails(state.number.trim().split(" ").join("").substring(0, 6), function() {
                        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .initPayment */ .yK)(data, router));
                    });
                } else {
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .initPayment */ .yK)(data, router));
                }
            }
            /**
       * This was added as to fix bank redirection after confirming OTP on our temporary domains, as the redirection
       * only happens on domain i.e. showroom.dotpe.in & not on our path -> showroom.dotpe.in/${domain},
       * so redirection details are saved here.
       */ if ((storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain) && (storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.domain) === null || ref3 === void 0 ? void 0 : ref3.startsWith("d-temporary"))) {
                var ref5, ref6;
                sessionStorage.setItem("cardPaymentDetails", JSON.stringify({
                    paymentMethod: "card",
                    redirectionUrl: storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.store_info) === null || ref5 === void 0 ? void 0 : ref5.store_url,
                    storeDomain: storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.store_info) === null || ref6 === void 0 ? void 0 : ref6.domain
                }));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "card-payment-box",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "card-wrapper",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "top-wrap",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "icon-wrapper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    loading: "lazy",
                                    src: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .cc_icons */ .P2[state.cardType] || _config__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CDN_SERVER_URL */ .Z.CDN_SERVER_URL + "image/ic-credit-card.svg",
                                    alt: "cardType"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "form-wrap",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            children: "Card Number"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "text",
                                            inputMode: "numeric",
                                            className: "form-control",
                                            placeholder: "XXXX XXXX XXXX XXXX",
                                            onChange: function(e) {
                                                return handleInputChange("number", e.target.value);
                                            },
                                            onBlur: function() {
                                                return validateCardNumber(state.number);
                                            },
                                            value: state.number,
                                            pattern: "[0-9.]+"
                                        }),
                                        !state.isCardNumberValid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                            className: "error",
                                            children: "Enter valid card number"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "inline-form-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "Expires"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    placeholder: "MM/YY",
                                                    value: state.expiry,
                                                    pattern: "\\d*",
                                                    maxLength: "7",
                                                    onChange: function(e) {
                                                        return handleInputChange("expiry", e.target.value, e);
                                                    },
                                                    onBlur: function() {
                                                        var ref;
                                                        return (state === null || state === void 0 ? void 0 : state.expiry) && validateCardMonth(state === null || state === void 0 ? void 0 : (ref = state.expiry) === null || ref === void 0 ? void 0 : ref.split(" ").join(""));
                                                    }
                                                }),
                                                state.isCardMonthInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                    className: "error",
                                                    children: state.isCardMonthInvalid
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "CVV"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "password",
                                                    value: state.cvv,
                                                    inputMode: "numeric",
                                                    pattern: "[0-9]*",
                                                    className: "form-control",
                                                    placeholder: state.cvvLength === 4 ? "* * * *" : "* * *",
                                                    maxLength: state.cvvLength,
                                                    onChange: function(e) {
                                                        return handleInputChange("cvv", e.target.value);
                                                    },
                                                    onBlur: function(e) {
                                                        return validateCardCVV(state.cvv);
                                                    }
                                                }),
                                                state.isCardCVVInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                    className: "error",
                                                    children: state.isCardCVVInvalid
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: onPayBtnClick,
                    className: "cta-btn ".concat(((ref1 = (ref = state.number) === null || ref === void 0 ? void 0 : ref.split(" ")) === null || ref1 === void 0 ? void 0 : ref1.join("").length) < 14 ? "o-50" : "", " ").concat(checkForValidCardLogic() ? "o-100 pointer" : "o-50"),
                    disabled: loader || !checkForValidCardLogic(),
                    children: !loader ? getCtaBtnText() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/images/ellipLoader1.gif",
                        className: "img h1"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardPaymentBox);


/***/ }),

/***/ 96930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ canDisablePlaceOrder; }
/* harmony export */ });
/* harmony import */ var src_redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40190);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23653);
/* harmony import */ var src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40804);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6337);





var canDisablePlaceOrder = function() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        showMessage: true,
        message: "This is a demo website, you need a live version to proceed this action."
    };
    var ref, ref1, ref2, ref3, // for new stores
    ref4, // for old stores
    ref5;
    var showMessage = args.showMessage, message = args.message;
    var storeInfo = (ref = src_redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.storeReducer) === null || ref1 === void 0 ? void 0 : ref1.store;
    // Disable place order flow for play preview URLs.
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_4__/* .IS_CLIENT */ .kc && ((ref2 = window.location.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.BUILDER_PREVIEW))) {
        return true;
    }
    // Enable place order flow for stores having theme and staging environment.
    if ( false || !!(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.premium)) {
        return false;
    }
    var disablePlaceOrder = ((ref3 = window.location.pathname) === null || ref3 === void 0 ? void 0 : ref3.includes(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.BUILDER_PREVIEW)) || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.new_subscription_web_status) === src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_STORE_WEBSITE_STATUS.ACTIVE_NOT_LIVE */ .d6.ACTIVE_NOT_LIVE || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.domain_info) === null || ref5 === void 0 ? void 0 : ref5.domain_type) === 0;
    if (disablePlaceOrder && showMessage && (message === null || message === void 0 ? void 0 : message.trim())) {
        (0,src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__/* .toastNotifyError */ .Lu)(message);
    }
    return disablePlaceOrder;
};


/***/ }),

/***/ 8824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ getCardType; },
/* harmony export */   "G9": function() { return /* binding */ isExpiryInvalid; },
/* harmony export */   "TH": function() { return /* binding */ isCardValid; },
/* harmony export */   "Tn": function() { return /* binding */ formatExpiry; },
/* harmony export */   "XW": function() { return /* binding */ cardNumberFormat; },
/* harmony export */   "bX": function() { return /* binding */ formatCvc; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59637);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);



var cardNumberFormat = function(value) {
    var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || "";
    var parts = [];
    for(var i = 0, len = match.length; i < len; i += 4){
        parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
        return parts.join(" ");
    } else {
        return value;
    }
};
var getCardType = function(cardNum) {
    // accept only digits, dashes or spaces
    var numericDashRegex = /^[\d\-\s]+$/;
    if (!numericDashRegex.test(cardNum)) return "";
    var payCardType = "DebitCard";
    /* var regexMap = [
    {regEx: /^4[0-9]{5}/ig,cardType: "VISA"},
    {regEx: /^5[1-5][0-9]{4}/ig,cardType: "MASTERCARD"},
    {regEx: /^3[47][0-9]{3}/ig,cardType: "AMEX"},
    {regEx: /^(5[06-8]\d{4}|6\d{5})/ig,cardType: "MAESTRO"}
  ];*/ var regexMap = [
        {
            regEx: /^4/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.VISA */ .WK.VISA
        },
        {
            regEx: /^5[1-5]/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.MASTERCARD */ .WK.MASTERCARD
        },
        {
            regEx: /^3[47]/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.AMEX */ .WK.AMEX
        },
        {
            regEx: /^(5[06-8]\d{4}|6\d{5})/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.MAESTRO */ .WK.MAESTRO
        }, 
    ];
    for(var j = 0; j < regexMap.length; j++){
        if (cardNum.match(regexMap[j].regEx)) {
            payCardType = regexMap[j].cardType;
            break;
        }
    }
    if (cardNum.indexOf("50") === 0 || cardNum.indexOf("60") === 0 || cardNum.indexOf("65") === 0) {
        var g = "508500-508999|606985-607984|608001-608500|652150-653149";
        var i = g.split("|");
        for(var d = 0; d < i.length; d++){
            var c = parseInt(i[d].split("-")[0], 10);
            var f = parseInt(i[d].split("-")[1], 10);
            if (cardNum.substr(0, 6) >= c && cardNum.substr(0, 6) <= f && cardNum.length >= 6) {
                payCardType = "RUPAY";
                break;
            }
        }
    }
    return payCardType;
};
var isCardValid = function(cardNum) {
    // accept only digits, dashes or spaces
    var numericDashRegex = /^[\d\-\s]+$/;
    if (!numericDashRegex.test(cardNum)) return false;
    // The Luhn Algorithm.
    var nCheck = 0;
    var nDigit = 0;
    var bEven = false;
    var strippedField = cardNum.replace(/\D/g, "");
    for(var n = strippedField.length - 1; n >= 0; n--){
        var cDigit = strippedField.charAt(n);
        nDigit = parseInt(cDigit, 10);
        if (bEven) {
            if ((nDigit *= 2) > 9) nDigit -= 9;
        }
        nCheck += nDigit;
        bEven = !bEven;
    }
    if (nCheck % 10 === 0) return true;
    return false;
};
var formatExpiry = function(event) {
    var eventData = event.nativeEvent && event.nativeEvent.data;
    var prevExpiry = event.target.value.split(" / ").join("/");
    if (!prevExpiry) return null;
    var expiry = prevExpiry;
    if (/^[2-9]$/.test(expiry)) {
        expiry = "0".concat(expiry);
    }
    if (prevExpiry.length === 2 && +prevExpiry > 12) {
        var _prevExpiry = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prevExpiry), head = _prevExpiry[0], tail = _prevExpiry.slice(1);
        expiry = "0".concat(head, "/").concat(tail.join(""));
    }
    if (/^1[/-]$/.test(expiry)) {
        return "01 / ";
    }
    expiry = expiry.match(/(\d{1,2})/g) || [];
    if (expiry.length === 1) {
        if (!eventData && prevExpiry.includes("/")) {
            return expiry[0];
        }
        if (/\d{2}/.test(expiry)) {
            return "".concat(expiry[0], " / ");
        }
    }
    if (expiry.length > 2) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(expiry.join("").match(/^(\d{2}).*(\d{2})$/) || [], 3), month = ref[1], year = ref[2];
        return [
            month,
            year
        ].join(" / ");
    }
    return expiry.join(" / ");
};
var formatCvc = function(cvc) {
    return (cvc.match(/\d+/g) || []).join("");
};
var ERROR_TEXT__INVALID_EXPIRY_DATE = "Expiry date is invalid";
var ERROR_TEXT__MONTH_OUT_OF_RANGE = "Expiry month must be between 01 and 12";
var ERROR_TEXT__YEAR_OUT_OF_RANGE = "Expiry year cannot be in the past";
var EXPIRY_DATE_REGEX = /^(\d{2})\/(\d{4}|\d{2})$/;
var MONTH_REGEX = /(0[1-9]|1[0-2])/;
var isExpiryInvalid = function(expiryDate) {
    var splitDate = expiryDate.split("/");
    if (!EXPIRY_DATE_REGEX.test(expiryDate)) {
        return ERROR_TEXT__INVALID_EXPIRY_DATE;
    }
    var expiryMonth = splitDate[0];
    if (!MONTH_REGEX.test(expiryMonth)) {
        return ERROR_TEXT__MONTH_OUT_OF_RANGE;
    }
    var expiryYear = splitDate[1];
    var currentYear = new Date().getFullYear();
    currentYear = parseInt(expiryYear.length === 4 ? currentYear : currentYear.toString().substr(-2), 10);
    if (currentYear > parseInt(expiryYear, 10)) {
        return ERROR_TEXT__YEAR_OUT_OF_RANGE;
    }
    return false;
};


/***/ }),

/***/ 70145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getEncrypDecryptStr; }
/* harmony export */ });
var getEncrypDecryptStr = function(str, type) {
    if (type === "encrypt" || type === "decrypt") {
        return type === "encrypt" ? btoa(encodeURIComponent(str)) : decodeURIComponent(atob(str));
    } else return str;
};


/***/ })

}]);